import axiosInstance from "./axios-instance";

const listGroupTypes = (params) =>
    axiosInstance.get("/app/tk-group-types", { params, cache: false }).then(res => res);

const listGroups = (params) =>
    axiosInstance.get("/app/tk-groups", { params, cache: false }).then(res => res);

const getGroup = (groupId) =>
    axiosInstance.get(`/app/tk-groups/${groupId}`, { cache: false }).then(res => res);

const createGroup = (group) =>
    axiosInstance.post("/app/tk-groups", group).then(res => res);

const updateGroup = (groupId, group) =>
    axiosInstance.patch(`/app/tk-groups/${groupId}`, group).then(res => res);

const updateGroupMembers = (groupId, members) =>
    axiosInstance.put(`/app/tk-groups/${groupId}/members`, members).then(res => res);

const createSession = (groupId, session) =>
    axiosInstance.post(`/app/tk-groups/${groupId}/sessions`, session).then(res => res);

const updateSession = (groupId, sessionId, session) =>
    axiosInstance.patch(`/app/tk-groups/${groupId}/sessions/${sessionId}`, session).then(res => res);

export default {
    listGroupTypes,
    listGroups,
    getGroup,
    createGroup,
    updateGroup,
    updateGroupMembers,
    createSession,
    updateSession,
};
